import { render, staticRenderFns } from "./FbUpdateContactSsi.vue?vue&type=template&id=84e4ae06"
import script from "./FbUpdateContactSsi.vue?vue&type=script&lang=ts"
export * from "./FbUpdateContactSsi.vue?vue&type=script&lang=ts"
import style0 from "./FbUpdateContactSsi.vue?vue&type=style&index=0&id=84e4ae06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports